// extracted by mini-css-extract-plugin
export default {"popup":"popup_popup__QCO1E","hasMaxWidth":"popup_hasMaxWidth__pfQzq","closeBtn":"popup_closeBtn__BL0HG"};